<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item"><router-link to="/kr/mypage/result/out">외래진료 내역</router-link></li>
            <!-- <li class="tab-menu__item"><router-link to="/kr/mypage/result/drug">약 처방 내역</router-link></li> -->
            <li class="tab-menu__item active"><router-link to="/kr/mypage/result/check">검사 내역 조회</router-link></li>
        </ul>
    </div>
    <template v-if="pageMode == 'list'">
        <p class="bullet03">검사결과는 3일 후에 조회 됩니다.</p>
        <div class="table-wrap">
            <div class="table-search">
                <VueDatePicker v-model="selectedDateRange" locale="ko"
                        :enable-time-picker="false" :format="customFormat"
                        :week-start="0" :day-class="getDayClass"
                        :select-text="'선택'" :cancel-text="'취소'"
                        :range="true" :multi-calendars="true" placeholder="날짜를 선택하세요."/>
                
                <ul class="table-select__button-wrap">
                    <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 1}" @click="setSelectedPeriod(1)">1개월</a></li>
                    <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 3}" @click="setSelectedPeriod(3)">3개월</a></li>
                    <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 6}" @click="setSelectedPeriod(6)">6개월</a></li>
                    <li><a href="javascript:;" :class="{'table-select--sub-btn': true, 'active': selectedPeriod == 12}" @click="setSelectedPeriod(12)">12개월</a></li>
                </ul>
                <!-- <a href="javascript:;" class="main-button c-main" @click="getCheckList">검색</a> -->
            </div>
            <template v-if="Object.keys(checkDateList).length == 0">
                <div class="emphasis">
                    <div class="emphasis--icon">
                        <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-icon01.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-icon01-brain.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-icon01-mom.svg" class="" alt="">
                    </div>
                    <h3 class="title02">
                        해당 기간의 검사결과가 없습니다. <br>
                        기간을 다시 확인해주세요.
                    </h3>
                </div>
            </template>
            <div v-else class="info" v-for="(checkList, idx) in checkDateList">
                <h3 class="bullet01">{{idx}}</h3>
                <div class="table">
                    <table>
                        <colgroup>
                            <col style="width:30%;">
                            <col style="width:30%;">
                            <col style="width:20%;">
                            <col style="width:20%;">
                            <col style="width:20%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>진료과</th>
                                <th>검사 항목</th>
                                <th>검사 구분</th>
                                <th>검사실</th>
                                <th>검사내역 보기</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(check, idx) in checkList">
                                <td>{{check.DEPT_NM}}</td>
                                <td>{{check.EXRM_TYPE}}</td>
                                <td>{{check.EXRM_GRP}}</td>
                                <td>{{check.EXM_CTG_ABBR_NM}}</td>
                                <td>
                                    <div class="botton-wrap" v-if="check.SPCM_NO">
                                        <!-- <router-link :to="`/kr/mypage/result/checkDetail?inSelType=${setInSelType(check)}&spcmNo=${check.SPCM_NO}&exmCtgCd=${check.EXM_CTG_CD}`" class="main-button small c-gray">상세보기</router-link> -->
                                        <a href="javascript:;" class="main-button small c-gray" @click="viewDetail(check)">상세보기</a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </template>
    <template v-if="pageMode == 'detail'">
        <div class="info">
            <h3 class="bullet01">검사정보</h3>
            <div class="table column type03">
                <table>
                    <colgroup>
                        <col style="width:20%;">
                        <col style="width:30%;">
                        <col style="width:20%;">
                        <col style="width:30%;">
                    </colgroup>
                    <tbody v-if="checkList.length > 0">
                        <tr>
                            <th>검사일자</th>
                            <td class="left">{{checkList[0].ACPT_DT.split(' ')[0]}}</td>
                        </tr>
                        <tr>
                            <th>진료과</th>
                            <td class="left">{{selectedCheck.DEPT_NM}}</td>
                            <th>검사 항목</th>
                            <td class="left">{{selectedCheck.EXRM_TYPE}}</td>
                        </tr>
                        <tr>
                            <th>검사 구분</th>
                            <td class="left">{{selectedCheck.EXRM_GRP}}</td>
                            <th>검사실</th>
                            <td class="left">{{selectedCheck.EXM_CTG_ABBR_NM}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">검사내역</h3>
            <div class="table">
                <table>
                    <colgroup>
                        <col style="width:34%;">
                        <col style="width:22%;">
                        <col style="width:22%;">
                        <col style="width:22%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>검사명</th>
                            <th>결과</th>
                            <th>참고치</th>
                            <th>단위</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="check in checkList">
                            <td>{{check.EITM_ABBR}}</td>
                            <td>{{check.EXRS_CNTE}}</td>
                            <td>{{check.SREFVAL}}</td>
                            <td>{{check.EXRS_UNIT}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="botton-wrap">
            <!-- <router-link to="/kr/mypage/result/check" class="sub-button c-gray">목록</router-link> -->
            <a href="javascript:;" class="sub-button c-gray" @click="viewList">목록</a>
        </div>
    </template>
    <kr_popup_certification v-if="popupVisible" @cancelNameCheck="hidePopup"/>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import SlideUpDown from 'vue-slide-up-down';

export default {
    components: {
        VueDatePicker,
        SlideUpDown,
    },
    data() {
        return {
            selectedDateRange: [new Date(), new Date()],
            selectedPeriod: 3,
            customFormat: 'yyyy-MM-dd',
            checkDateList: {},
            popupVisible: false,

            pageMode: 'list',

            selectedCheck: '',
            checkList: [],
        };
    },
    methods: {
        showPopup() {
            this.popupVisible = true;
        },
        hidePopup() {
            this.popupVisible = false;
            this.$router.push('/kr/mypage/mypage')
        },
        checkSuccess(data){
            if(data.iReturn === 0 && data.ptNo !== '' && data.ptNo !== null){
                // this.hidePopup()
                this.popupVisible = false;
                this.axios.get(this.api.member.info)
                    .then(res => {
                        if(res.data.ptNo) this.$store.state.myInfoStore.ptNo = res.data.ptNo;
                        this.setSelectedPeriod(1)
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }else{
                alert(data.sMessage)
            }
        },
        setSelectedPeriod(months) {
            const startDate = new Date()
            const endDate = new Date()
            startDate.setMonth(endDate.getMonth() - months)
            this.selectedDateRange = [startDate, endDate]
            this.selectedPeriod = months
            this.getCheckList()
        },
        getCheckList() {
            const searchParam = {
                IN_FROM_DT: this.$commonUtils.timestampToDateFormate(this.selectedDateRange[0], 'yyyyMMdd', ''),
                IN_TO_DT: this.$commonUtils.timestampToDateFormate(this.selectedDateRange[1], 'yyyyMMdd', '')
            }

            this.axios.get(this.api.mypage.checkList, {
                params: searchParam
            }).then(res => {
                const infoList = res.data
                this.checkDateList = {}
                let checkList = []
                if(Array.isArray(infoList)){
                    checkList = infoList
                } else {
                    checkList = [infoList]
                    return
                }

                //엄마아기병원이 아닌 경우
                if(this.$store.state.hospStore.hostNm != '엄마아기병원'){
                    //checkList의 EXRM_GRP '혈액'이 포함되는 데이터만 추출
                    checkList = checkList.filter(check => check.EXRM_GRP.indexOf('혈액') > -1)
                }

                if(checkList.length > 0){
                    let acptDt = this.formatDate(checkList[0].ACPT_DT)
                    
                    //날짜별 데이터 입력 key가 acptDt
                    for(const check of checkList){
                        check.ACPT_DT = this.formatDate(check.ACPT_DT,'.')
                        if(acptDt != check.ACPT_DT){
                            acptDt = check.ACPT_DT
                        }
                        
                        //날짜별로 데이터를 담을 배열 생성
                        if(!this.checkDateList[acptDt]){
                            this.checkDateList[acptDt] = []
                        }
                        
                        this.checkDateList[acptDt].push(check)
                        
                    }
                    
                    //checkDateList key값을 날짜로 내림차순 정렬
                    this.checkDateList = Object.keys(this.checkDateList).sort().reverse().reduce((obj, key) => {
                        obj[key] = this.checkDateList[key]
                        return obj
                    }, {})
                }
            })
        },
        formatDate(dateString){
            if(!dateString) return ''

            let formattedDateString = dateString.replace('오전', '').replace('오후', '');

            let date = new Date(formattedDateString);

            let formattedDate = date.getFullYear() + '.' + 
                                (date.getMonth() + 1).toString().padStart(2, '0') + '.' + 
                                date.getDate().toString().padStart(2, '0');

            return formattedDate
        },
        setInSelType(check){
            let result = 1
            if (check.EXRM_GRP && check.EXRM_GRP.indexOf('진단') > -1) {
                result = 2
            }
            return result
        },
        viewDetail(info){
            this.selectedCheck = info
            const searchParam = {}

            searchParam.IN_SEL_TYPE = this.setInSelType(info)
            searchParam.IN_CODE = info.SPCM_NO
            searchParam.IN_CODE2 = info.EXM_CTG_CD

            this.axios.get(this.api.mypage.checkDetail, {
                params: searchParam
            }).then(res => {
                this.checkList = res.data
                if(!Array.isArray(this.checkList)) this.checkList = [this.checkList]

                this.pageMode = 'detail'
            })
        },
        viewList(){
            this.pageMode = 'list'
            this.checkList = []
        }
    },
    mounted() {
        if(this.$commonUtils.isEmpty(this.$store.state.myInfoStore.ptNo)){
            this.$store.commit('setNiceType', '')
            this.popupVisible = true

            window.addEventListener("message", (event) => {
                try {

                    if (event.data && event.data.source === "react-devtools-content-script") {
                        return;
                    }

                    const receivedData = JSON.parse(event.data); // JSON 파싱
                    if (receivedData.callFunction === "checkSuccess") {
                        this.checkSuccess(receivedData.data); // 데이터 전달
                    }
                } catch (e) {
                    console.error("Invalid JSON data received:", e);
                }
            });
        }else{
            this.setSelectedPeriod(1)
        }

        // 테이블의 .table에 클릭 이벤트를 추가
        const tables = document.querySelectorAll('.table');

        tables.forEach((table) => {
            // .table 요소의 가상 요소 부분을 클릭한 것처럼 처리할 수 있게,
            // 테이블의 `::before`가 클릭될 수 있는 영역을 감싸는 영역을 클릭 이벤트로 처리
            table.addEventListener('click', () => {
                // 테이블에 'active' 클래스를 토글
                table.classList.add('active');
            });
        });
    },
};
</script>

<style scoped></style>